var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoEllipsis = function SvgIcoEllipsis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M168 256a56 56 0 1 0 112 0 56 56 0 1 0-112 0",
    style: {
      opacity: 0.4
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 312a56 56 0 1 0 0-112 56 56 0 1 0 0 112m320 0a56 56 0 1 0 0-112 56 56 0 1 0 0 112",
    className: "ico-ellipsis_svg__fa-primary"
  })));
};
export default SvgIcoEllipsis;